import { useAppDispatch, useAppSelector } from '../redux/hooks'

import { closeHomebase, openHomebase, selectHomebaseIsOpen } from '../redux/slices/homebase'

// Base Show/Hide toggle hook
const useToggleBase = (): (() => void) => {
  const homebaseIsOpen = useAppSelector(selectHomebaseIsOpen)
  const dispatch = useAppDispatch()
  const toggleBase = (): void => {
    if (homebaseIsOpen) {
      dispatch(closeHomebase())
    } else {
      dispatch(openHomebase())
    }
  }

  return toggleBase
}

export default useToggleBase
